module.exports = __webpack_public_path__ + "img/circle1.d436c4e3.png";